import {
  ChangeUnlockRecords,
  Dashboard,
  DeviceUnlockShow,
  PropertiesWithAmazonUnadded,
  RegisteredDevices,
  UnhealthyDevices,
  UnlockRecords,
} from "@admin/pages";
import {
  CourierServiceDetail,
  PickupServiceDetail,
  RentServiceDetail,
  ServiceLogDetailPage,
  ServiceLogListPage,
  StorageServiceDetail,
} from "@admin/pages/data-records";
import type { RouteObject } from "react-router-dom";

const mainDashboardList = [
  { index: true, element: <Dashboard /> },
  { path: "unlock-record", element: <UnlockRecords /> },
  { path: "charge-unlock-record", element: <ChangeUnlockRecords /> },
  { path: "devices/registered", element: <RegisteredDevices /> },
  { path: "devices/unhealthy", element: <UnhealthyDevices /> },
  { path: "devices/unlock/:id", element: <DeviceUnlockShow /> },
  {
    path: "properties/no-amazon",
    element: <PropertiesWithAmazonUnadded />,
  },
] satisfies RouteObject[];

const serviceList = [
  { index: true, element: <ServiceLogListPage /> },
  { path: ":identity/events/:id", element: <ServiceLogDetailPage /> },
  { path: "pickup/:id", element: <PickupServiceDetail /> },
  { path: "courier/:id", element: <CourierServiceDetail /> },
  { path: "storage/:id", element: <StorageServiceDetail /> },
  { path: "rent/:id", element: <RentServiceDetail /> },
] satisfies RouteObject[];

export const dashboardRoute = [
  { path: "/service-records", children: serviceList },
  { path: "/dashboard", children: mainDashboardList },
] satisfies RouteObject[];
